<template>
    <section>
        <!-- 検索窓 -->
        <el-col :span="24" class="toolbar" style="padding-bottom: 0px;" v-loading="toolbarLoading">
            <el-form :inline="true" :model="filters">
                <el-form-item>
                    <el-button type="primary" v-on:click="exportCsv" v-if="adminRole">CSV出力</el-button>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="handleAdd">新規追加</el-button>
                </el-form-item>
                <el-pagination layout="prev, pager, next" @current-change="handleCurrentChange" :page-size="30"
                           :total="total" style="float:right;">
                </el-pagination>
            </el-form>
        </el-col>
        <!-- /検索窓 -->

        <!-- リスト -->
        <el-table :data="categories" highlight-current-row v-loading="listLoading" @selection-change="selsChange"
                  style="width: 100%;">
            <el-table-column type="selection" width="55">
            </el-table-column>
            <el-table-column prop="name" label="カテゴリ名" width="300" sortable>
            </el-table-column>
            <el-table-column label="更新日時" width="210" sortable>
                <template scope="scope">
                    {{ scope.row.updatedAt | formatDate }}
                </template>
            </el-table-column>
            <el-table-column label="操作" width="150">
                <template scope="scope">
                    <el-button size="small" @click="handleEdit(scope.$index, scope.row)">編集</el-button>
                    <el-button type="danger" size="small" @click="handleDel(scope.$index, scope.row)">削除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <!-- /リスト -->

        <!-- 一括削除 -->
        <el-col :span="24" class="toolbar">
            <el-button type="danger" @click="batchRemove" :disabled="this.sels.length===0">一括削除</el-button>
        </el-col>
        <!-- /一括削除 -->

        <!-- 編集画面 -->
        <el-dialog title="編集" v-model="editFormVisible" :close-on-click-modal="false" @close="closeEditForm">
            <el-form :model="editForm" label-width="80px" :rules="editFormRules" ref="editForm">
                <el-form-item label="ID" prop="id">
                    <el-input v-model="editForm.id" disabled></el-input>
                </el-form-item>
                <el-form-item label="カテゴリ名" prop="name">
                    <el-input v-model="editForm.name" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="作成日時">
                    <el-date-picker type="datetime"
                                    placeholder="作成日時"
                                    format="yyyy/MM/dd HH:mm"
                                    v-model="editForm.createdAt"
                                    disabled>
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="更新日時">
                    <el-date-picker type="datetime"
                                    placeholder="更新日時"
                                    format="yyyy/MM/dd HH:mm"
                                    v-model="editForm.updatedAt"
                                    disabled>
                    </el-date-picker>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click.native="closeEditForm">取消</el-button>
                <el-button type="primary" @click.native="editSubmit" :loading="editLoading">登録</el-button>
            </div>
        </el-dialog>
        <!-- /編集画面 -->

        <!-- 新規追加 -->
        <el-dialog title="新規追加" v-model="addFormVisible" :close-on-click-modal="false" @close="closeAddForm">
            <el-form :model="addForm" label-width="80px" :rules="addFormRules" ref="addForm">
                <el-form-item label="カテゴリ名" prop="name">
                    <el-input v-model="addForm.name" auto-complete="off"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click.native="closeAddForm">取消</el-button>
                <el-button type="primary" @click.native="addSubmit" :loading="addLoading">登録</el-button>
            </div>
        </el-dialog>
        <!-- /新規追加 -->

    </section>
</template>

<script>
    import util from '../../common/js/util'
    import * as CategoryRequest from '../../api/category';
    import ElOption from "../../../node_modules/element-ui/packages/select/src/option.vue";
    import { formatDate } from "../../components/filters/format";
    import config from "../../config/app";
    import moment from "moment";
    import * as User from '../../api/cognitoUser';

    export default {
        components: { ElOption },
        filters: { formatDate },
        data() {
            return {
                filters: {
                    name: ''
                },
                categories: [],
                total: 0,
                page: 1,
                listLoading: false,
                sels: [],
                adminRole: User.checkAdminRoleBySession(),
                toolbarLoading: false,

                // 編集系
                editFormVisible: false,
                editLoading: false,
                editFormRules: {
                    name: [
                        { required: true, message: 'カテゴリ名を入力してください', trigger: 'blur' }
                    ]
                },
                editForm: {
                    id: '',
                    name: '',
                },

                // 新規系
                addFormVisible: false,
                addLoading: false,
                addFormRules: {
                    name: [
                        { required: true, message: 'カテゴリ名を入力してください', trigger: 'blur' }
                    ]
                },
                addForm: {
                    name: '',
                }

            }
        },
        methods: {
            handleCurrentChange(val) {
                this.page = val;
                this.getCategories();
            },
            getCategories() {
                let params = {
                    params: {
                        order: "updatedAt",
                        sort: "DESC",
                        count: config.pageCount,
                        offset: (this.page - 1) * config.pageCount,
                    }
                };
                this.listLoading = true;
                CategoryRequest.count()
                    .then(res => {
                        this.total = res.data.count;
                    });
                CategoryRequest
                    .search(params)
                    .then(res => {
                        this.categories = res.data.relationCategories;
                        this.listLoading = false;
                    });
            },
            handleDel: function (index, row) {
                this.$confirm('削除してもよろしいですか？', '確認', {
                    type: 'warning'
                })
                .then(() => {
                    this.listLoading = true;
                    return CategoryRequest.remove(row.id, {})
                    .then(() => {
                        this.$message({
                            message: '削除しました',
                            type: 'success'
                        });
                    })
                    .catch(err => {
                        this.$message({
                            message: 'コンテンツに紐付いたカテゴリが含まれています。コンテンツを削除してから再度お試し下さい。',
                            type: 'warning'
                        });
                    });
                })
                .then(() => {
                    this.getCategories();
                    this.listLoading = false;
                })
                .catch(err => {/*キャンセル*/});
            },
            handleEdit: function (index, row) {
                this.editFormVisible = true;
                this.editForm = Object.assign({}, row);
            },
            handleAdd: function () {
                this.addFormVisible = true;
                this.addForm = {
                    name: '',
                    parent: '',
                };
            },
            closeAddForm() {
                this.$refs.addForm.resetFields();
                this.addFormVisible = false;
            },
            closeEditForm() {
                this.$refs.editForm.resetFields();
                this.editFormVisible = false;
            },
            editSubmit: function () {
                this.$refs.editForm.validate((valid) => {
                    if (valid) {
                        this.$confirm('登録してもよろしいですか？', '確認', {})
                            .then(() => {
                                this.editLoading = true;
                                const params = Object.assign({}, this.editForm);
                                return CategoryRequest.edit(this.editForm.id, params);
                            })
                            .then(res => {
                                this.editLoading = false;
                                this.$message({
                                    message: '登録しました',
                                    type: 'success'
                                });
                                this.closeEditForm();
                                this.getCategories();
                            });
                    }
                });
            },
            addSubmit: function () {
                this.$refs.addForm.validate((valid) => {
                    if (valid) {
                        this.$confirm('登録してもよろしいですか？', '確認', {})
                            .then(() => {
                                this.addLoading = true;
                                const params = Object.assign({}, this.addForm);
                                console.log(params);
                                return CategoryRequest.add(params);
                            })
                            .then(res => {
                                this.addLoading = false;
                                this.$message({
                                    message: '登録しました',
                                    type: 'success'
                                });
                                this.closeAddForm();
                                this.getCategories();
                            });
                    }
                });
            },
            selsChange: function (sels) {
                this.sels = sels;
            },
            batchRemove: function () {
                const ids = this.sels.map(item => item.id);
                this.$confirm('選択した項目を削除してもよろしいですか？', '確認', {
                    type: 'warning'
                })
                .then(() => {
                    this.listLoading = true;
                    return CategoryRequest.batchRemove(ids, {})
                    .then(() => {
                        this.$message({
                            message: '削除しました',
                            type: 'success'
                        });
                    })
                    .catch(err => {
                        this.$message({
                            message: 'コンテンツに紐付いたカテゴリが含まれています。コンテンツを削除してから再度お試し下さい。',
                            type: 'warning'
                        });
                    });
                })
                .then(() => {
                    this.getCategories();
                    this.listLoading = false;
                })
                .catch(err => {/*キャンセル*/});
            },
            exportCsv: async function() {
                this.listLoading = true;
                this.toolbarLoading = true;
                // ヘッダ行
                const columns = [
                    'カテゴリ名',
                    '更新日時',
                ];
                const header = columns.join(',') + '\n';

                // データ取得（全件）
                const params = {
                    params: {
                        order: 'updatedAt',
                        sort: 'DESC',
                        count: this.total,
                    }
                };
                const category = await CategoryRequest
                        .search(params)
                        .then(res => {
                            return res.data.relationCategories;
                        });

                let arrCategory = [];
                for (var i = 0; i < category.length; i++) {
                    const data = [
                        category[i].name,
                        formatDate(category[i].updatedAt),
                    ];
                    arrCategory.push(data);
                }
                const body = arrCategory.join('\n');

                // CSVダウンロード
                const iconv = require("iconv-lite");
                const data = iconv.encode(header + body, 'windows-31j');
                const blob = new Blob([ data ], { "type" : "text/csv" });
                const url = window.URL.createObjectURL(blob);

                let link = document.createElement('a');
                link.download = 'swipe_category_' + moment().format("YYYYMMDD") + '.csv';
                link.href = url;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                this.listLoading = false;
                this.toolbarLoading = false;
            }
        },
        mounted() {
            this.getCategories();
            CategoryRequest.all()
                .then(response => {
                    this.total = response.data.length
                });
        }
    }

</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// Category.vue?69c980eb